import AkButton from '@atlaskit/button/standard-button';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import styles from './YellowButton.less';

export default class YellowButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    spacing: PropTypes.string,
    text: PropTypes.string.isRequired,
  };

  render() {
    return (
      <span className={styles.yellowButtonContainer}>
        <AkButton
          // @ts-expect-error [MC-2850] - TS2339 - Property 'className' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
          className={classNames(styles.yellowButton, this.props.className)}
          // @ts-expect-error [MC-2850] - TS2339 - Property 'href' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
          href={this.props.href}
          // @ts-expect-error [MC-2850] - TS2339 - Property 'onClick' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
          onClick={this.props.onClick}
          // @ts-expect-error [MC-2850] - TS2339 - Property 'spacing' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
          spacing={this.props.spacing}
        >
          {/* @ts-expect-error [MC-2850] - TS2339 - Property 'text' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
          {this.props.text}
        </AkButton>
      </span>
    );
  }
}
